var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncidents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11046 3.49152H1.11046C0.865 3.49152 0.666016 3.6905 0.666016 3.93596V15.4915C0.666016 15.737 0.865 15.936 1.11046 15.936H2.0349",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18635 15.936H10.8886C11.6249 15.936 12.2219 15.339 12.2219 14.6026V10.1582C12.2219 9.91272 12.0229 9.71373 11.7775 9.71373H9.1819C8.86215 9.71409 8.56684 9.54268 8.40857 9.26485L5.36857 3.9404C5.3048 3.83026 5.21846 3.73484 5.11523 3.6604",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 5.26929H3.77713L5.99935 9.71373H0.666016V5.26929Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4434 9.71375V11.0471C10.4434 11.2925 10.6423 11.4915 10.8878 11.4915H12.2211",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11111 19.4915C6.82933 19.4915 8.22222 18.0986 8.22222 16.3804C8.22222 14.6622 6.82933 13.2693 5.11111 13.2693C3.39289 13.2693 2 14.6622 2 16.3804C2 18.0986 3.39289 19.4915 5.11111 19.4915Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11068 17.7137C5.84706 17.7137 6.44401 17.1168 6.44401 16.3804C6.44401 15.644 5.84706 15.0471 5.11068 15.0471C4.3743 15.0471 3.77734 15.644 3.77734 16.3804C3.77734 17.1168 4.3743 17.7137 5.11068 17.7137Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0753 15.936H25.9998C26.2452 15.936 26.4442 15.737 26.4442 15.4915V3.93596C26.4442 3.6905 26.2452 3.49152 25.9998 3.49152H22.5158C22.1967 3.49146 21.9021 3.66244 21.7438 3.93952L18.7002 9.26574C18.542 9.54281 18.2473 9.71379 17.9282 9.71374H15.3331C15.0877 9.71374 14.8887 9.91272 14.8887 10.1582V14.6026C14.8887 15.339 15.4856 15.936 16.222 15.936H18.9242",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4447 5.26929H23.3335L21.1113 9.71373H26.4447V5.26929Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6664 9.71375V11.0471C16.6664 11.2925 16.4675 11.4915 16.222 11.4915H14.8887",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 19.4915C23.718 19.4915 25.1109 18.0986 25.1109 16.3804C25.1109 14.6622 23.718 13.2693 21.9998 13.2693C20.2816 13.2693 18.8887 14.6622 18.8887 16.3804C18.8887 18.0986 20.2816 19.4915 21.9998 19.4915Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9993 17.7137C22.7357 17.7137 23.3327 17.1168 23.3327 16.3804C23.3327 15.644 22.7357 15.0471 21.9993 15.0471C21.263 15.0471 20.666 15.644 20.666 16.3804C20.666 17.1168 21.263 17.7137 21.9993 17.7137Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8882 7.93594L8.66602 3.93594L11.7771 5.71372L11.3327 0.824829L13.5549 3.93594",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2214 7.93594L18.4436 3.93594L15.3325 5.71372L15.7769 0.824829L13.5547 3.93594",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5549 7.93596L12.666 7.49152",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5547 6.6026V7.93593L14.4436 7.49149",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidents);
export default __webpack_public_path__ + "static/media/Incidents.8d690e3342d55dbe19d942b09b0b2369.svg";
export { ForwardRef as ReactComponent };